import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useResponsive } from "../hooks/useResponsive";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import DataTableBase from "../common/DataTableBase";
// import PageNavbar from "./PageNavbar";
import PostAwardApprovalListToolbox from "./PostAwardApprovalListToolbox";
import PostAwardApprovalListReferenceDocument from "./PostAwardApprovalListReferenceDocument";
import { DataTable } from "primereact/datatable";
import PostAwardApprovalListHistory from "./PostAwardApprovalListHistory";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SlidingDrawer from "../common/SlidingDrawer";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Button as PrimeButton } from "primereact/button";
import CustomDialog from "../common/CustomDialog";
import _ from "lodash";
import { capitalizeLeadingText } from "../../utils/textFormat";
import { useLocation } from "react-router-dom";
// import filingMasters from "../../data/filingMasters.json";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import PostAwardApprovalListApprove from "./PostAwardApprovalListApprove";
import PostAwardApprovalListComments from "./PostAwardApprovalListComments";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import ReactLoading from "react-loading";
import axios from "axios";
import InsertCommentRoundedIcon from "@mui/icons-material/InsertCommentRounded";
import IconButton from "@mui/material/IconButton";
import { InputSwitch } from "primereact/inputswitch";
import { DateTime } from "luxon";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { Stack } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { CircularProgress } from "@mui/material";
import states from "../../data/StateLookup.json";
import { Dropdown } from "primereact/dropdown";

import ClientFilingMasterContext from '../../context/client-filing-master/ClientFilingMasterContext';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { tokens } from "../../theme/tokens";
import { TrackNowButton } from "../ui/TrackNowButton";
import { TextField, InputAdornment } from "@mui/material";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { useCommonDetailsContext } from "../../context/Common/common";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const PostAwardApprovalList = () => {
  const { isMobile, mdUp } = useResponsive();
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const containerBackgroundColor = tokens.colors.offWhite;
  const tableBackgroundColor = containerBackgroundColor;
  const enableForzen = !isMobile
  const [selectedFiling, setSelectedFiling] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [pendingTableData, setPendingTableData] = useState([]);
  const [completedTableData, setCompletedTableData] = useState([]);
  const [pendingMyRequests, setPendingMyRequests] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [comments, setComments] = React.useState([]);
  const [stateArray, setStateArray] = useState([]);
  const [postawardfederalArray, setPostAwardFederalArray] = useState([]);
  const [postawardstateArray, setPostAwardStateArray] = useState([]);
  const [awardingAgencyList, setAwardingAgencyList] = useState([])
  const [programNameList, setProgramNameList] = useState([]);
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [commentActivityHistory, setCommentActivityHistory] = React.useState([]);
  const overlayRefs = useRef({});

  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const {
    fetchConfigurations,
  } = clientFilingMasterContext;

  const [federalFilterSelectedValues, setFederalFilterSelectedValues] =
    React.useState({
      federalCategories: [],
    });
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    approverName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    stateInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    workflowStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    // jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // jsicontactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    awardingAgency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    awardType: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  });
  const getFilingCategories = (filingMaster) => {
    return _.map(filingMaster.businessCategory, "businessCategoryName").join(
      ", "
    );
  };
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    getFilingMasterApprovals,
    setFilingMasterApprovalsCompleted,
    filingMasterApprovalsCompleted,
    setFilingMasterApprovalsPending,
    filingMasterApprovals,
    filingMasterLoaded,
    getFilingMasterWorkflowComments,
    getFilingMasterWorkflow,
    getProgramName,
    getAwardingAgencies
  } = filingMasterContext;

  const authContext = useContext(AuthContext);
  const { roleType, authId, authUser, toLocalDateTime } = authContext;
  // const data = filingMasterApprovals;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [showFilter, setShowFilter] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [jurisdiction, setJurisdiction] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [viewAll, setViewAll] = useState(true);
  const [value, setValue] = React.useState("1");
  const [expandedRows, setExpandedRows] = useState(null);
  const [filingPeriodTable, setFilingPeriodTable] = useState([]);
  const [attachments, setAttachments] = React.useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isClearIcon, setIsClearIcon] = useState(false)
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedFilterColumn, setSelectedFilterColumn] = useState("");
  const [selectedFilterCondition, setSelectedFilterCondition] = useState("");
  const [selectedFilterValue, setSelectedFilterValue] = useState("");

  const pendingFilterColumns = [
    "approverName",
    "filingName",
    "filingFrequency",
    "awardType",
    "awardingAgency",
    "stateList",
    "ruleInfo",
    "required",
    "jsicontactName",
    "juristiction",
  ];

  const completedFilterColumns = [
    "filingName",
    "filingFrequency",
    "awardType",
    "awardingAgency",
    "stateList",
    "ruleInfo",
    "required",
    "workflowStatus",
    "jsicontactName",
    "juristiction",
  ];

  const [postawardagencyArray, setPostAwardAgencyArray] = useState([]);
  const [postawardtypeArray, setPostAwardTypeArray] = useState([]);
  const [awardAgenciesList, setAwadAgenciesList] = useState([])
  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [resetListOnRefresh, setResetListOnRefresh] = useState(false);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });

  const closeFilter = () => {
    // // console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => false);
  };

  function handleViewAllClick() {
    setViewAll(true);
  }

  function handlePaginationClick() {
    setViewAll(false);
  }

  const toLocalDate = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy "),
        "dd-MMM-yyyy ",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy ");
      // // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const newBusinessCategory = (oldBC, newBC) => {
    let BC =
      oldBC.length > 0 ? oldBC.map((ele) => ele.businessCategoryName) : [];
    let changedBC = newBC.map((ele) => ele.businessCategoryName);
    // // console.log("newBusinessCategory", BC, changedBC);
    return {
      field: "Business Category",
      old: BC.reduce((acc, item) => acc + (acc === "" ? "" : " , ") + item, ""),
      new: changedBC.reduce(
        (acc, item) => acc + (acc === "" ? "" : " , ") + item,
        ""
      ),
    };
  };




  const getProgramNames = (oldLisenceId, newLisenceId) => {
    // console.log(
    //   "getProgramNames ",
    //   oldLisenceId,
    //   newLisenceId,
    //   programNameList
    // );

    const oldLisenceName =
      oldLisenceId === null
        ? ""
        : programNameList.find((item) => item.programId === oldLisenceId);
    const newLisenceName =
      newLisenceId === null
        ? ""
        : programNameList.find((item) => item.programId === newLisenceId);

    // console.log("getProgramNames ", oldLisenceName, newLisenceName);

    return {
      field: "programName",
      old: oldLisenceName === "" ? "" : oldLisenceName.programName,
      new: newLisenceName === "" ? "" : newLisenceName.programName,
    };
  };

  // const awardAgencyList = [
  //   { AwardingAgencyId: 1, AwardingAgencyName: "NTIA" },
  //   { AwardingAgencyId: 2, AwardingAgencyName: "USDA RUS" },
  //   { AwardingAgencyId: 3, AwardingAgencyName: "Treasury" },
  // ];
  const getAwardAgencyLisenceName = (oldLisenceId, newLisenceId) => {
    // console.log(
    //   "getAwardAgencyLisenceName ",
    //   oldLisenceId,
    //   newLisenceId,
    //   awardingAgencyList
    // );

    const oldLisenceName =
      oldLisenceId === null
        ? ""
        : awardingAgencyList.find(
          (item) => item.awardingAgencyId === oldLisenceId
        );
    const newLisenceName =
      newLisenceId === null
        ? ""
        : awardingAgencyList.find(
          (item) => item.awardingAgencyId === newLisenceId
        );
    // console.log("getAwardAgencyLisenceName ", oldLisenceName, newLisenceName);

    return {
      field: "awardingAgency",
      old: oldLisenceName === "" ? "" : oldLisenceName.awardingAgencyName,
      new: newLisenceName === "" ? "" : newLisenceName.awardingAgencyName,
    };
  };

  const awardTypeList = [
    { AwardTypeId: 1, AwardTypeName: "Direct Federal Award" },
    { AwardTypeId: 2, AwardTypeName: "Direct State Award" },
    { AwardTypeId: 3, AwardTypeName: "Pass Through Award" },
  ];
  const getAwardTypeLicenseName = (oldLisenceId, newLisenceId) => {
    // console.log(
    //   "getAwardTypeLicenseName ",
    //   oldLisenceId,
    //   newLisenceId,
    //   awardTypeList
    // );

    const oldLisenceName =
      oldLisenceId === null
        ? ""
        : awardTypeList.find((item) => item.AwardTypeId === oldLisenceId);
    const newLisenceName =
      newLisenceId === null
        ? ""
        : awardTypeList.find((item) => item.AwardTypeId === newLisenceId);
    // console.log("getAwardTypeLicenseName ", oldLisenceName, newLisenceName);

    return {
      field: "awardType",
      old: oldLisenceName === "" ? "" : oldLisenceName.AwardTypeName,
      new: newLisenceName === "" ? "" : newLisenceName.AwardTypeName,
    };
  };

  const getModified = async () => {
    console.log("FETCH GETpROGRAM getModified");
    let modefiedSel = await Promise.all(
      selectedFiling.map(async (ele) => {
        let modified = await fetchFilingMasterPendingHistory(ele.draftId);
        // console.log("getModified modified", modified);
        if (modified.length > 0) {
          let activity = modified.map((ele) => {
            let changed = [];
            if (ele.process === "Modified") {
              // console.log("ele", ele);
              let keys = Object.keys(ele);
              keys.forEach((key) => {
                const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
                // console.log("key", key, ele[key], ele[`new${capitalized}`]);
                if (key === "awardTypeId") {
                  if (ele[key] !== ele[`new${capitalized}`]) {
                    let awardlisenceChange = getAwardTypeLicenseName(
                      ele[key],
                      ele[`new${capitalized}`]
                    );
                    changed.push(awardlisenceChange);
                  }
                } else if (key === "awardingAgencyId") {
                  if (ele[key] !== ele[`new${capitalized}`]) {
                    let agencylisenceChange = getAwardAgencyLisenceName(
                      ele[key],
                      ele[`new${capitalized}`]
                    );
                    changed.push(agencylisenceChange);
                  }
                } else if (key === "programId") {
                  if (ele[key] !== ele[`new${capitalized}`]) {
                    let programNameChange = getProgramNames(
                      ele[key],
                      ele[`new${capitalized}`]
                    );
                    changed.push(programNameChange);
                  }
                }
                // if (
                //   key === "businessCategory" &&
                //   ele.businessCategory !== null &&
                //   ele.newBusinessCategory !== null &&
                //   ele.newBusinessCategory.length > 0
                // ) {
                //   let isSame = _.isEqual(
                //     ele.businessCategory,
                //     ele.newBusinessCategory
                //   );
                // //   console.log("businessCategory isSame", isSame);
                //   if (!isSame) {
                //     changed.push(
                //       newBusinessCategory(
                //         ele.businessCategory,
                //         ele.newBusinessCategory
                //       )
                //     );
                //   }
                // }
                else if (
                  key === "filingPeriods" &&
                  ele.newFilingPeriods !== null &&
                  ele.newFilingPeriods.length > 0
                ) {
                  if (ele.filingPeriods === null) {
                    let filingPeriods = [];
                    let newFilingPeriods = ele.newFilingPeriods.sort(function (
                      a,
                      b
                    ) {
                      return new Date(b.StartDate) - new Date(a.StartDate);
                    });
                    // console.log(
                    //   "filingPeriods newFilingPeriods",
                    //   filingPeriods,
                    //   newFilingPeriods
                    // );
                    changed.push({
                      field: "Due Date",
                      old: filingPeriods.map((periods) =>
                        toLocalDate(periods.dueDate)
                      ),
                      new: newFilingPeriods.map((periods) =>
                        toLocalDate(periods.dueDate)
                      ),
                    });
                  } else {
                    let isSame = _.isEqual(
                      ele.filingPeriods,
                      ele.newFilingPeriods
                    );
                    // console.log("filingPeriods isSame", isSame);
                    if (!isSame) {
                      let filingPeriods = ele.filingPeriods.sort(function (
                        a,
                        b
                      ) {
                        return new Date(b.StartDate) - new Date(a.StartDate);
                      });
                      let newFilingPeriods = ele.newFilingPeriods.sort(
                        function (a, b) {
                          return new Date(b.StartDate) - new Date(a.StartDate);
                        }
                      );
                      // console.log(
                      //   "filingPeriods newFilingPeriods",
                      //   filingPeriods,
                      //   newFilingPeriods
                      // );
                      // let oldFP = [];
                      // let newFP = [];
                      // filingPeriods.forEach((periods, i) => {
                      //   if (
                      //     filingPeriods[i].StartDate ===
                      //       newFilingPeriods[i].StartDate &&
                      //     !_.isEqual(filingPeriods[i], newFilingPeriods[i])
                      //   ) {
                      //     oldFP.push(filingPeriods[i]);
                      //     newFP.push(newFilingPeriods[i]);
                      //   }
                      // });
                      // console.log("filingPeriods oldFP", oldFP, newFP);
                      changed.push({
                        field: "Due Date",
                        old: filingPeriods.map((periods) =>
                          toLocalDate(periods.dueDate)
                        ),
                        new: newFilingPeriods.map((periods) =>
                          toLocalDate(periods.dueDate)
                        ),
                      });
                    }
                  }
                } else if (
                  key === "filingAttachments" &&
                  (ele.filingAttachments !== null ||
                    ele.newFilingAttachments !== null)
                ) {
                  let isSame = _.isEqual(
                    ele.filingAttachments,
                    ele.newFilingAttachments
                  );
                  // console.log("filingAttachments isSame", isSame);
                  if (!isSame) {
                    let filingAttachments =
                      ele.filingAttachments !== null
                        ? ele.filingAttachments
                        : [];
                    let newFilingAttachments =
                      ele.newFilingAttachments !== null
                        ? ele.newFilingAttachments
                        : [];
                    // let oldFA = _.differenceWith(
                    //   filingAttachments,
                    //   newFilingAttachments,
                    //   _.isEqual
                    // );
                    // let newFA = _.differenceWith(
                    //   newFilingAttachments,
                    //   filingAttachments,
                    //   _.isEqual
                    // );
                    // // console.log(
                    //   "filingAttachments newFA",
                    //   filingAttachments,
                    //   newFilingAttachments
                    // );

                    changed.push({
                      field: "Attachments",
                      old: filingAttachments,
                      new: newFilingAttachments,
                      draftId: ele.newDraftId,
                    });
                  }
                } else if (
                  ele[`new${capitalized}`] !== undefined &&
                  ele[key] !== ele[`new${capitalized}`] &&
                  key !== "draftId" &&
                  key !== "filingPeriods" &&
                  key !== "filingAttachments" &&
                  key !== "businessCategory"
                ) {
                  changed.push({
                    field: key,
                    old: ele[key],
                    new: ele[`new${capitalized}`],
                  });
                }
              });
            }

            if (changed.length > 0) {
              ele.changedData = changed;
              // console.log("changedData", ele.changedData);
            }
            return ele;
          });
          // console.log("getModified activity", activity);
          modified = activity;
        }
        // console.log("getModified ele", ele);
        ele.modified = modified;
        return ele;
      })
    );
    // console.log("getModified modefiedSel", modefiedSel);
    return modefiedSel;
  };

  const search = useRef()
  const applyGlobalFilter = () => {
    console.log("applyGlobalFilter", search.current.value, isClearIcon)
    let _filters = { ...filters };
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = "";
      setIsClearIcon(false);
      onFilterChange({ filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
      onFilterChange({ filters });
    }
    setFilters(_filters);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
    setSelectedFilterColumn("");
    setSelectedFilterCondition("");
    setSelectedFilterValue("");
  };

  const getFilterColumnsForCurrentTab = () => {
    const columns = value === "1" ? pendingFilterColumns : completedFilterColumns;
    const labels = {
      approverName: "Approver Name",
      filingName: "Filing Name",
      filingFrequency: "Filing Frequency",
      awardType: "Award Type",
      awardingAgency: "Award Agency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      workflowStatus: "Status",
      jsicontactName: "JSI Staff",
      juristiction: "Jurisdiction",
    };

    return columns.map((field) => ({ value: field, label: labels[field] || field }));
  };

  const getFilterChipLabel = (field) => {
    const labels = {
      approverName: "Approver Name",
      filingName: "Filing Name",
      filingFrequency: "Filing Frequency",
      awardType: "Award Type",
      awardingAgency: "Award Agency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      workflowStatus: "Status",
      jsicontactName: "JSI Staff",
      juristiction: "Jurisdiction",
    };

    if (labels[field]) {
      return labels[field];
    }

    return String(field || "")
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const toSortedUniqueStringList = (list, keys = []) => {
    const values = (Array.isArray(list) ? list : [])
      .map((item) => {
        if (typeof item === "string") {
          return item;
        }
        if (item && typeof item === "object") {
          for (const key of keys) {
            if (item[key] !== undefined && item[key] !== null) {
              const candidate = String(item[key]).trim();
              if (candidate) {
                return candidate;
              }
            }
          }
        }
        return "";
      })
      .map((item) => String(item || "").trim())
      .filter(Boolean);

    return Array.from(new Set(values)).sort((a, b) =>
      a.toLowerCase().localeCompare(b.toLowerCase())
    );
  };

  const getFilterValueOptions = (field) => {
    if (field === "required") return ["True", "False"];
    if (field === "juristiction") return ["Federal", "State", "Both"];
    if (field === "stateList") return stateArray || [];
    if (field === "federalCategories") return postawardfederalArray || [];
    if (field === "stateCategories") return postawardstateArray || [];
    if (field === "awardType") return postawardtypeArray || [];
    if (field === "awardingAgency") return postawardagencyArray || [];
    return [];
  };

  const shouldUseMultiSelectFilterValue = (field, condition) =>
    (field === "stateList" && condition === FilterMatchMode.CONTAINS) ||
    (field === "federalCategories" && condition === FilterMatchMode.CONTAINS) ||
    (field === "stateCategories" && condition === FilterMatchMode.CONTAINS) ||
    (field === "awardType" && condition === FilterMatchMode.CONTAINS) ||
    (field === "awardingAgency" && condition === FilterMatchMode.CONTAINS);

  const shouldUseRadioFilterValue = (field, condition) =>
    (field === "stateList" &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS)) ||
    (field === "required" && condition === FilterMatchMode.EQUALS) ||
    ((field === "federalCategories" || field === "stateCategories") &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS)) ||
    (field === "awardType" &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS)) ||
    (field === "juristiction" && condition === FilterMatchMode.EQUALS) ||
    (field === "awardingAgency" &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS));

  const handleFilterApply = (filterConfig) => {
    console.log("Filter applied:", filterConfig);
    const allowedColumns = value === "1" ? pendingFilterColumns : completedFilterColumns;
    if (!allowedColumns.includes(filterConfig.field)) {
      return;
    }

    const updatedFilters = activeFilters.filter(
      (filter) => filter.field !== filterConfig.field
    );
    const newFilter = {
      ...filterConfig,
      label: getFilterChipLabel(filterConfig.field),
      id: Date.now()
    };
    setActiveFilters([...updatedFilters, newFilter]);

    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = filterConfig.value;
      _filters[filterConfig.field].constraints[0].matchMode = filterConfig.matchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const applyFilterFromPopover = () => {
    const hasFilterValue = Array.isArray(selectedFilterValue)
      ? selectedFilterValue.length > 0
      : !!selectedFilterValue;

    if (!selectedFilterColumn || !selectedFilterCondition || !hasFilterValue) {
      return;
    }

    const normalizedMatchMode =
      shouldUseMultiSelectFilterValue(selectedFilterColumn, selectedFilterCondition) &&
        selectedFilterCondition === FilterMatchMode.CONTAINS
        ? FilterMatchMode.IN
        : selectedFilterCondition;

    handleFilterApply({
      field: selectedFilterColumn,
      matchMode: normalizedMatchMode,
      value: selectedFilterValue,
      matchModeLabel:
        normalizedMatchMode === FilterMatchMode.NOT_CONTAINS
          ? "is not"
          : normalizedMatchMode === FilterMatchMode.EQUALS
            ? "is"
            : "contains",
    });

    handleFilterClose();
  };

  const handleFilterClear = () => {
    setActiveFilters([]);
    setSelectedFilterColumn("");
    setSelectedFilterCondition("");
    setSelectedFilterValue("");
    setFilters({
      ...filters,
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setFederalFilterSelectedValues([]);
    setRecordsInView(0);
    setIsLoading(true);
    setData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setRefreshRecordList(true);
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find(f => f.id === filterId);
    setActiveFilters(activeFilters.filter(f => f.id !== filterId));

    if (filterToRemove) {
      let _filters = { ...filters };
      if (filterToRemove.field && _filters[filterToRemove.field]) {
        _filters[filterToRemove.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
    }
  };


  const approveDraft = async () => {
    // console.log("Approving Draft", selectedFiling, "Role:", roleType);
    if (selectedFiling && selectedFiling.length === 0) {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
      // } else if (selectedFiling.length !== 1 && authUser.roleName === "Admin") {
      //   setAlertMessage("Please select a single Filing Master Record");
      //   setShowAlert(true);
    } else if (selectedFiling && selectedFiling.length !== 0) {
      let modefiedSel = await getModified();
      // console.log("Approving getModified", modefiedSel);
      setShowFilter(() => true);
    }
    // else {
    //   setAlertMessage("Please Select a Filing Master Record");
    //   setShowAlert(true);
    // }
  };

  const fetchFilingMasterAttachments = async (draftId, filingId) => {
    // console.log("fetchFilingMasterAttachments props", draftId, value);
    try {
      let attachmentList;
      if (value === "2") {
        attachmentList = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
        );
      } else {
        attachmentList = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterDraftAttachments/${draftId}`
        );
      }
      let list = attachmentList.data.data.map((ele) => ({ ...ele, filingId }));
      setAttachments(() => list);
      // console.log("fetchFilingMasterAttachments res", attachmentList);
    } catch (error) {
      // console.log("@@Error:", error);
    }
  };

  const closeAttachments = () => {
    // console.log("Toggling Show Filter", showAttachments);
    setShowAttachments(() => false);
  };
  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };

  const fetchFilingMasterHistory = async (selectedFiling) => {
    // console.log("fetchFilingMasterHistory props", filingId);
    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAudit?FilingId=${selectedFiling.filingId}`
      );
      setActivityHistory(() => history.data.data);
      // console.log("fetchFilingMasterHistory res", history);
    } catch (error) {
      // console.log("@@Error:", error);
    }
    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowCommentsaudit?WorkflowId=${selectedFiling.workflowId}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const fetchFilingMasterPendingHistory = async (filingId) => {
    // console.log("fetchFilingMasterPendingHistory props", filingId);
    return new Promise(async (resolve, reject) => {
      try {
        const history = await axios.get(
          `${API_BASE_URL}/FilingMaster/MasterFilingPendingAudit?DraftId=${filingId}`
        );
        // console.log("fetchFilingMasterPendingHistory res", history);
        if (history.data) {
          resolve(history.data.data);
        }
        resolve([]);
      } catch (error) {
        // console.log("@@Error:", error);
        reject(error);
      }
    });
  };

  const displayHistory = async () => {
    // console.log("displayHistory", selectedFiling[0]);

    if (!selectedFiling || selectedFiling.length === 0) {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
      return;
    }

    if (selectedFiling.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
      return;
    }

    let selected = selectedFiling[0];
    const rawFilingId = selected?.filingId !== null && selected?.filingId !== undefined ? String(selected.filingId).trim() : "";
    const hasFilingId = rawFilingId !== "" && rawFilingId !== "0" && rawFilingId !== "null" && rawFilingId !== "undefined";

    // Pending tab rows may not have filingId yet; use draft audit.
    if (value === "1") {
      if (hasFilingId) {
        fetchFilingMasterHistory(selected);
        setShowHistory(() => true);
        return;
      }

      if (selected?.draftId) {
        try {
          const pendingHistory = await fetchFilingMasterPendingHistory(selected.draftId);
          
          if ((!pendingHistory || pendingHistory.length === 0) && !hasFilingId) {
            setAlertMessage(
              "The file does not have any history yet because it has been newly created. History will appear once changes are made and saved."
            );
            setShowAlert(true);
            return;
          }

          setActivityHistory(() => pendingHistory || []);
          
          if (selected?.workflowId) {
            try {
              const history = await axios.get(
                `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowCommentsaudit?WorkflowId=${selected.workflowId}`
              );
              setCommentActivityHistory(() => history.data.data);
            } catch (error) {
              console.log("@@Error:", error);
              setCommentActivityHistory(() => []);
            }
          } else {
            setCommentActivityHistory(() => []);
          }
          
          setShowHistory(() => true);
        } catch (error) {
          console.log("@@Error:", error);
          setAlertMessage("Unable to load Activity History");
          setShowAlert(true);
        }
      } else {
        setAlertMessage("Unable to load Activity History");
        setShowAlert(true);
      }
      return;
    }

    if (value === "2" && selected?.workflowId && getFilingMasterWorkflow) {
      try {
        const workflowResponse = await getFilingMasterWorkflow(selected.workflowId);
        const workflowData =
          workflowResponse?.data?.data ||
          workflowResponse?.data ||
          workflowResponse;
        if (workflowData) {
          selected = { ...selected, ...workflowData };
        }
      } catch (error) {
        console.log("@@Error:", error);
      }
    }

    // Completed tab can contain filed records and rejected draft-based records.
    const workflowStatus = (selected?.workflowStatus || "").toLowerCase();
    const responseStatus = (selected?.responseStatus || "").toLowerCase();
    const isRejectedRecord =
      workflowStatus === "rejected" || responseStatus === "rejected";

    if (isRejectedRecord && selected?.draftId) {
      try {
        const pendingHistory = await fetchFilingMasterPendingHistory(selected.draftId);
        if ((!pendingHistory || pendingHistory.length === 0) && !hasFilingId) {
          setAlertMessage(
            "The file does not have any history yet because it has been newly created. History will appear once changes are made and saved."
          );
          setShowAlert(true);
          return;
        }

        if ((!pendingHistory || pendingHistory.length === 0) && hasFilingId) {
          fetchFilingMasterHistory(selected);
          setShowHistory(() => true);
          return;
        }

        setActivityHistory(() => pendingHistory || []);

        if (selected?.workflowId) {
          try {
            const history = await axios.get(
              `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowCommentsaudit?WorkflowId=${selected.workflowId}`
            );
            setCommentActivityHistory(() => history.data.data);
          } catch (error) {
            console.log("@@Error:", error);
            setCommentActivityHistory(() => []);
          }
        } else {
          setCommentActivityHistory(() => []);
        }

        setShowHistory(() => true);
        return;
      } catch (error) {
        console.log("@@Error:", error);
      }
    }

    if (hasFilingId) {
      fetchFilingMasterHistory(selected);
      setShowHistory(() => true);
      return;
    }

    if (selected?.draftId) {
      try {
        const pendingHistory = await fetchFilingMasterPendingHistory(selected.draftId);
        setActivityHistory(() => pendingHistory || []);

        if (selected?.workflowId) {
          try {
            const history = await axios.get(
              `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowCommentsaudit?WorkflowId=${selected.workflowId}`
            );
            setCommentActivityHistory(() => history.data.data);
          } catch (error) {
            console.log("@@Error:", error);
            setCommentActivityHistory(() => []);
          }
        } else {
          setCommentActivityHistory(() => []);
        }

        setShowHistory(() => true);
        return;
      } catch (error) {
        console.log("@@Error:", error);
      }
    }

    setAlertMessage("Unable to load Activity History");
    setShowAlert(true);
  };

  const fetchFilingMasterComments = async (data) => {
    // console.log("@@Fetch FilingMasters1:", getFilingMasterWorkflowComments);
    if (getFilingMasterWorkflowComments) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        let dataId =
          value === "2"
            ? { id: data.filingId, type: "filing" }
            : { id: data.workflowId, type: "workflow" };
        const commentList = await getFilingMasterWorkflowComments(dataId);
        setComments(() => commentList);
        // console.log("@@Fetch FilingMasters2 comments:", commentList);
      } catch (error) {
        // console.log("@@Error:", error);
      }
    }
  };

  const displayAttachments = async (rowData) => {
    // console.log("##selectedFiling", selectedFiling[0]);
    // console.log("##selectedFiling-length", selectedFiling.length);
    // console.log("##RowData", rowData);
    // console.log("LengthSelectedFiling", selectedFiling.length);
    if (rowData && rowData.draftId) {
      // console.log(`##RowData-FilingId :${rowData.draftId}`);
      fetchFilingMasterAttachments(rowData.draftId, rowData.filingId);
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].draftId
    ) {
      // console.log(`Fetching Attachment for :`, selectedFiling);
      fetchFilingMasterAttachments(
        selectedFiling[0].draftId,
        selectedFiling[0].filingId
      );
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (selectedFiling.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const addComment = (rowData) => {
    // console.log("Display Comments", selectedFiling);
    // console.log("Fetching Comments", selectedFiling);
    if (rowData && rowData.workflowId) {
      fetchFilingMasterComments(rowData);
      setShowComments(() => true);
      setSelectedFiling([]);
      setSelectedRowData(rowData);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].workflowId
    ) {
      // console.log(`Fetching Commnet for :${selectedFiling[0].workflowId}`);
      setSelectedRowData(null);

      fetchFilingMasterComments(selectedFiling[0]);

      setShowComments(() => true);
    } else {
      setAlertMessage("Please select a single Record");
      setShowAlert(true);
    }
  };

  const closeComments = () => {
    // console.log("Toggling Show Filter", showComments);
    setShowComments(() => false);
  };
  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : (stateCode || "");
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const jusrisdictionItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("##Options:", options);
    if (
      !federalFilterSelectedValues.jurisdiction &&
      options?.filterModel?.value
    ) {
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={options.value}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const getProgramList = async () => {
    // console.log("getProgramList");
    try {
      const progList = await getProgramName();
      // console.log("getProgramList res", progList);
      setProgramNameList(progList || []);
      const programLookup = toSortedUniqueStringList(progList, [
        "programName",
        "businessCategoryName",
        "name",
        "label",
        "value",
      ]);
      setPostAwardFederalArray(programLookup);
      setPostAwardStateArray(programLookup);
      return;
    } catch (error) {
      // console.log("getProgramList Error:", error);
    }
  };
  const getAwardingAgencyList = async () => {
    if (getAwardingAgencies) {

      try {
        const catList = await getAwardingAgencies();
        console.log("getAwardingAgencyList", catList);
        setAwardingAgencyList(catList || []);
        setPostAwardAgencyArray(
          toSortedUniqueStringList(catList, [
            "awardingAgencyName",
            "name",
            "label",
            "value",
          ])
        );

      } catch (error) {
        // console.log("@@Error:", error);
      }
    }

  }

  const fetchAwardTypeList = async () => {
    try {
      const resList = await axios.get(`${API_BASE_URL}/Application/ListAwardType`);
      setPostAwardTypeArray(
        toSortedUniqueStringList(resList?.data, [
          "awardTypeName",
          "name",
          "label",
          "value",
        ])
      );
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const fetchFilingMasters = async () => {
    setIsLoading(true)
    let _filters = { ...filters };
    search && search.current && (search.current.value = "");
    _filters && _filters["global"] && (_filters["global"].value = "");
    setFilters(_filters);
    setIsClearIcon(false);
    // console.log("@@Fetch FilingMasters1:", getFilingMasterApprovals);
    await getProgramList();
    if (getFilingMasterApprovals) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        let formData;
        if (
          roleType?.includes("Admin-PostAward")
        ) {
          formData = {
            recordType: "postaward",
          };
        } else {
          formData = { approverId: authUser.userId, recordType: "postaward" };

        }
        const list = await getFilingMasterApprovals(formData);
        // console.log("@@FilingMasters:", list);
      } catch (error) {
        // console.log("@@Error:", error);
      }
    }
  };
  const fetchFilingMastersCompleted = async () => {
    setIsLoading(true)
    let _filters = { ...filters };
    search && search.current && (search.current.value = "");
    _filters && _filters["global"] && (_filters["global"].value = "");
    setFilters(_filters);
    setIsClearIcon(false);
    // console.log("@@Fetch FilingMastersCompPa:", selectedYear, value);
    // await getProgramList();
    // console.log("@@Fetch FilingMasters2:");

    try {
      let formData;
      let filingList;

      if (
        roleType?.includes("Admin-PostAward")
      ) {
        formData = {
          recordType: "postaward",
        };
      } else {
        formData = { approverId: authUser.userId, recordType: "postaward" };

      }
      if (formData?.approverId) {
        let listRes = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowList?ApproverId=${formData.approverId}&RecordType=${formData.recordType}&Year=${selectedYear}`
        );
        filingList = listRes.data.data
        // console.log("@@FilingMastersCompList:", listRes);
      } else {
        let listRes = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowList?&RecordType=${formData.recordType}&Year=${selectedYear}`
        );
        filingList = listRes.data.data
        // console.log("@@FilingMastersCompList:", listRes);
      }

      let postAwardList = filingList.filter(
        (ele) => ele.recordType === "PostAward"
      );
      // console.log("Show Table Data postAwardList", postAwardList);
      const updList = postAwardList
        .filter((item) => item.changesInprogress)
        .map((item) => {
          // console.log(`filtered data ...`, item);
          const _stateList = getStateName(item.stateInfo);

          if (item.juristiction?.includes("Federal")) {
            return {
              ...item,
              federalCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateCategories: null,
              stateList: _stateList,
              awardType:
                item.awardType.length > 0
                  ? item.awardType[0].awardTypeName
                  : "",
              awardingAgency:
                item.awardingAgency.length > 0
                  ? item.awardingAgency[0].awardingAgencyName
                  : "",
            };
          } else if (item.juristiction?.includes("Both")) {
            return {
              ...item,
              federalCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateList: _stateList,
              awardType:
                item.awardType.length > 0
                  ? item.awardType[0].awardTypeName
                  : "",
              awardingAgency:
                item.awardingAgency.length > 0
                  ? item.awardingAgency[0].awardingAgencyName
                  : "",
            };
          } else {
            return {
              ...item,
              stateCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              federalCategories: null,
              stateList: _stateList,
              awardType:
                item.awardType.length > 0
                  ? item.awardType[0].awardTypeName
                  : "",
              awardingAgency:
                item.awardingAgency.length > 0
                  ? item.awardingAgency[0].awardingAgencyName
                  : "",
            };
          }
        });
      let completedList = updList.filter(
        (ele) => ele.workflowStatus !== "Pending"
      );
      // console.log("filter completedList :", completedList, updList);
      // completedList = completedList.filter(
      //   (value, index, self) =>
      //     index === self.findIndex((t) => t.filingId === value.filingId)
      // );

      // Storing latest records if completedList has same filingname based on updateDate

      let latestUpdates = {};

      completedList.forEach((ele) => {
        const filingId = ele.filingId;

        // Check if the filingId is already in the latestUpdates object
        if (latestUpdates[filingId]) {
          // Compare the updateDate with the stored one
          const storedUpdateDate = latestUpdates[filingId].updateDate;
          const currentUpdateDate = ele.updateDate;

          // If the current updateDate is greater, update the stored object
          if (currentUpdateDate > storedUpdateDate) {
            latestUpdates[filingId] = ele;
          }
        } else {
          // If filingId is not in latestUpdates, add it
          latestUpdates[filingId] = ele;
        }
      });

      completedList = Object.values(latestUpdates);
      // console.log("duplicate completedList :", completedList, updList);
      setCompletedTableData(() => completedList);

    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      setIsLoading(false)
    }
  };

  const onRowSelect = (e) => {
    // console.log("@@RowSelect:", e);
  };

  const getAllAttachment = async (updList) => {
    updList = await Promise.all(
      updList.map(async (ele) => {
        ele.attachment = await getFileAttachment(ele);
        return ele;
      })
    );
    setData(() => updList);
  };

  const getFileAttachment = async (ele) => {
    // console.log("getFileAttachment-->", ele);
    await axios
      .get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachmentsGetById/${ele.filingId}`
      )
      .then((res) => {
        // console.log("getFileAttachment res", ele, ele.filingId, res.data);
        if (res.data) {
          return res.data.attachmentPath;
        }
      });
  };
  useEffect(() => {
    console.log("FETCH getAwardingAgencyList LIST")
    getAwardingAgencyList();
    fetchAwardTypeList();
  }, []);


  useEffect(() => {
    if (filingMasterLoaded) {
      // console.log("Show Table Data", filingMasterApprovals);
      // let postAwardList = filingMasterApprovals.filter(
      //   (ele) => ele.recordType === "PostAward"
      // );
      // console.log("Show Table Data postAwardList", postAwardList);
      // const updList = postAwardList
      //   .filter((item) => item.changesInprogress)
      //   .map((item) => {
      //     // console.log(`filtered data ...`, item);
      //     const _stateList = getStateName(item.stateInfo);

      //     if (item.juristiction?.includes("Federal")) {
      //       return {
      //         ...item,
      //         federalCategories:
      //           item.programInfo.length > 0
      //             ? item.programInfo[0].programName
      //             : "",
      //         stateCategories: null,
      //         stateList: _stateList,
      //         awardType:
      //           item.awardType.length > 0
      //             ? item.awardType[0].awardTypeName
      //             : "",
      //         awardingAgency:
      //           item.awardingAgency.length > 0
      //             ? item.awardingAgency[0].awardingAgencyName
      //             : "",
      //       };
      //     } else if (item.juristiction?.includes("Both")) {
      //       return {
      //         ...item,
      //         federalCategories:
      //           item.programInfo.length > 0
      //             ? item.programInfo[0].programName
      //             : "",
      //         stateCategories:
      //           item.programInfo.length > 0
      //             ? item.programInfo[0].programName
      //             : "",
      //         stateList: _stateList,
      //         awardType:
      //           item.awardType.length > 0
      //             ? item.awardType[0].awardTypeName
      //             : "",
      //         awardingAgency:
      //           item.awardingAgency.length > 0
      //             ? item.awardingAgency[0].awardingAgencyName
      //             : "",
      //       };
      //     } else {
      //       return {
      //         ...item,
      //         stateCategories:
      //           item.programInfo.length > 0
      //             ? item.programInfo[0].programName
      //             : "",
      //         federalCategories: null,
      //         stateList: _stateList,
      //         awardType:
      //           item.awardType.length > 0
      //             ? item.awardType[0].awardTypeName
      //             : "",
      //         awardingAgency:
      //           item.awardingAgency.length > 0
      //             ? item.awardingAgency[0].awardingAgencyName
      //             : "",
      //       };
      //     }
      //   });
      // const _jusrisdictions = updList.map((item) =>
      //   item.juristiction ? item.juristiction : ""
      // );
      // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      // setJurisdiction(_uniqJurisdictions);
      // setData(() => updList);
      // let pendingList = updList.filter(
      //   (ele) => ele.workflowStatus === "Pending"
      // );
      // // console.log("filter pendingList :", pendingList, updList);
      // setPendingTableData(() => pendingList);
      // // let completedList = updList.filter(
      // //   (ele) => ele.workflowStatus !== "Pending"
      // // );
      // // // console.log("filter completedList :", completedList, updList);
      // // completedList = completedList.filter(
      // //   (value, index, self) =>
      // //     index === self.findIndex((t) => t.filingId === value.filingId)
      // // );
      // // // console.log("duplicate completedList :", completedList, updList);
      // // setCompletedTableData(() => completedList);
      // setIsLoading(false);
    }
  }, [filingMasterLoaded]);

  const findProgramName = (programId) => {
    // console.log("findProgramName:", programId, programNameList);
    if (programId === null) {
      return "";
    } else if (programNameList.length > 0) {
      let name = programNameList.find(
        (ele) => ele.programId === programId
      ).programName;
      // console.log("findProgramName: name", name);
      return name;
    }
  };

  useEffect(() => {
    let list = states.map((ele) => ele.state);
    setStateArray(list);
    getProgramList();
    // fetchFilingMasters();
    setRecordsInView(0)
    setIsLoading(true);
    setData([]);
    setPendingTableData([])
    setIsFilterChange([])
    setSortingData({ sortBy: "", sortOrder: "" })
    setFederalFilterSelectedValues([])
    setRefreshRecordList(true)
  }, []);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  useEffect(() => {
    if (value === "2") {
      setRecordsInView(0)
      setIsLoading(true);
      setData([]);
      setPendingTableData([])
      setCompletedTableData([])
      setFilingMasterApprovalsCompleted([])
      setIsFilterChange([])
      setSortingData({ sortBy: "", sortOrder: "" })
      setFederalFilterSelectedValues([])
      setRefreshRecordList(true)
    }
  }, [selectedYear]);

  const fetchConfigs = async () => {
    if (fetchConfigurations) {
      let config = await fetchConfigurations();
      let startYear = config.find(
        (ele) => ele.configItem === 'StartYear'
      ).configItemValue;
      let currentYear = config.find(
        (ele) => ele.configItem === 'CurrentYear'
      ).configItemValue;
      startYear = parseInt(startYear);
      currentYear = parseInt(currentYear);
      const yearsInBetween = [];
      for (let year = startYear; year <= currentYear + 1; year++) {
        yearsInBetween.push(year);
      }
      setYearsList(yearsInBetween);
      setSelectedYear(currentYear);
      // console.log(
      //   'configCheck',
      //   config,
      //   'StartYear',
      //   startYear,
      //   'currentYear',
      //   currentYear,
      //   'yearsInBetween',
      //   yearsInBetween
      // );
    }
  };
  useEffect(() => {
    fetchConfigs()
  }, [])


  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);


  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!federalFilterSelectedValues.required &&
      options?.filterModel?.value) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          ;
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const postawardTypeRowFilterTemplate = (options) => {
    let awardTypeOptionList = postawardtypeArray.sort()
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.awardTypeName || []}
        options={awardTypeOptionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.awardTypeName || []}
        options={awardTypeOptionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  const postawardAgencyRowFilterTemplate = (options) => {
    const awardAgenciesOptions = awardingAgencyList.map((item) => item.awardingAgencyName)
    console.log("postawardAgencyRowFilterTemplate", postawardagencyArray, awardAgenciesList, awardAgenciesOptions);

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.awardingAgencyName || []}
        options={awardAgenciesOptions}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          options.filterCallback(e.value, options.index);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.awardingAgencyName || []}
        options={awardAgenciesOptions}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardAgencyRowFilterTemplate:", e.value, masters);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          options.filterCallback(e.value, options.index);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };


  const federalFilterElement = (options, field) => {
    // console.log("##Options1234:", JSON.parse(JSON.stringify(data)));
    let optionsList = [];
    data
      .map((item) => item[field])
      .filter(Boolean)
      .map((item) => {
        optionsList.push(item);
      });
    optionsList = optionsList.filter((item, i) => {
      return i === optionsList.lastIndexOf(item);
    });

    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });

          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    // console.log("##Options:", options);
    if (!federalFilterSelectedValues.stateList && options.filterModel.value) {
      options.filterModel.value = [];
      options.value = [];
    }

    const isContainsMode =
      options.filterModel?.matchMode === "contains" ||
      options.filterModel?.matchMode === "in";

    return isContainsMode ? (
      <MultiSelect
        value={federalFilterSelectedValues.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.stateList || null}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  const displayTimeStamp = (rowData) => {
    return rowData.recentDate ? toLocalDateTime(rowData.recentDate) : ""
  }

  const parseCellList = (value) =>
    typeof value === "string"
      ? value.split(",").map((item) => item.trim()).filter(Boolean)
      : [];

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const row = cellElement?.closest("tr");
    const body = row?.parentElement;

    if (row && body) {
      const rows = Array.from(body.children).filter(
        (node) => node.tagName === "TR"
      );
      const rowIndex = rows.indexOf(row);

      if (rowIndex >= rows.length - 3) {
        return "up";
      }
      if (rowIndex <= 2) {
        return "down";
      }
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }
    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;
    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();
    const targetElement = event.currentTarget;

    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const renderExpandableCell = ({ list, overlayKey, title }) => {
    if (list.length === 0) return "";

    const hasValue = list.length > 0;
    const hasMore = list.length > 1;
    const firstItem = list[0];
    const remainingCount = Math.max(list.length - 1, 0);

    return (
      <div className='tableBtn' style={{ position: "relative", width: "100%" }}>
        <button
          type='button'
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          style={{
            background: "transparent",
            border: "none",
            cursor: hasValue ? "pointer" : "default",
            width: "100%",
            padding: 0,
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              color: tableHeaderColor,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {firstItem}
            </span>
            {hasMore && (
              <span
                style={{
                  flex: "0 0 auto",
                  fontSize: "12px",
                  color: tableHeaderColor,
                  whiteSpace: "nowrap",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            className='client-profile-overlay-panel postaward-master-approval-overlay-panel'
            showCloseIcon
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
              {title}
            </Typography>
            <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {list.map((item, idx) => (
                  <li key={`${item}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const CellListDisplayFederal = (rowData, field) => {
    const value = rowData[field] || "";
    const categories = parseCellList(value);

    const title = field === "federalCategories"
      ? "Who Must File Federal"
      : "Who Must File in State";

    const overlayKey = `${field}-${rowData.workflowId || rowData.filingId}`;

    return renderExpandableCell({
      list: categories,
      overlayKey: overlayKey,
      title: title,
    });
  };

  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: tableHeaderColor,
            cursor: "pointer",
            transition: "font-weight 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.fontWeight = '600';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.fontWeight = '400';
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "12rem",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "20rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: tableBackgroundColor,
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  useEffect(() => {
    // console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    // console.log("pendingMyRequests", pendingMyRequests);
  }, [pendingMyRequests]);

  const renderHeader = () => {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
          background: containerBackgroundColor,
          p: 2,
          borderRadius: "8px",
        }}
      >
        {/* TITLE */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              color: tableHeaderColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            POST AWARD FILING MASTER APPROVALS ({totalRecords})
          </Typography>
        </Grid>

        {/* FILTER + CHIPS */}
        <Grid item xs={12} md={7}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
              sx={{
                fontSize: "12px",
                padding: "4px 12px",
                minHeight: "28px",
              }}
            >
              + Filter
            </TrackNowButton>

            {activeFilters.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {activeFilters.map((filter) => (
                  <Box
                    key={filter.id}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "20px",
                      px: 1.5,
                      py: 0.5,
                      fontSize: "13px",
                    }}
                  >
                    {filter.label || getFilterChipLabel(filter.field)}:{" "}
                    {Array.isArray(filter.value)
                      ? filter.value.join(", ")
                      : filter.value}

                    <IconButton
                      size="small"
                      onClick={() => removeFilter(filter.id)}
                      sx={{ ml: 0.5 }}
                    >
                      ×
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>

        {/* SEARCH */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <TextField
              inputRef={search}
              placeholder="Search by Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: containerBackgroundColor,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? (
                        <GoogleMaterialIcon name="clear" size={20} />
                      ) : (
                        <GoogleMaterialIcon name="search" size={20} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    );
  };
  const renderCompletedHeader = () => {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
          background: containerBackgroundColor,
          p: 2,
          borderRadius: "8px",
        }}
      >
        {/* TITLE */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              color: tableHeaderColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            POST AWARD FILING MASTER APPROVALS ({totalRecords})
          </Typography>
        </Grid>

        {/* FILTER + CHIPS */}
        <Grid item xs={12} md={7}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
              sx={{
                fontSize: "12px",
                padding: "4px 12px",
                minHeight: "28px",
              }}
            >
              + Filter
            </TrackNowButton>

            {activeFilters.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {activeFilters.map((filter) => (
                  <Box
                    key={filter.id}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "20px",
                      px: 1.5,
                      py: 0.5,
                      fontSize: "13px",
                    }}
                  >
                    {filter.label || getFilterChipLabel(filter.field)}:{" "}
                    {Array.isArray(filter.value)
                      ? filter.value.join(", ")
                      : filter.value}

                    <IconButton
                      size="small"
                      onClick={() => removeFilter(filter.id)}
                      sx={{ ml: 0.5 }}
                    >
                      ×
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>

        {/* YEAR + SEARCH */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            {value === "2" && (
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Year</InputLabel>
                <Select value={selectedYear} label="Year" onChange={handleYearChange}>
                  {yearsList.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <TextField
              inputRef={search}
              placeholder="Search by Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: containerBackgroundColor,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? (
                        <GoogleMaterialIcon name="clear" size={20} />
                      ) : (
                        <GoogleMaterialIcon name="search" size={20} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    );
  };

  const updateSelectedWorkflow = (workflow) => {
    // // console.log("SELECT FILING UPDTAE", workflow);
    if (workflow) setSelectedFiling([workflow]);
    else setSelectedFiling([]);
  };

  const CustomCommentButton = ({ rowData }) => {
    const hasComments =
      rowData.hasComments === true ||
      rowData.hasComments === 1 ||
      rowData.hasComments === "1";
    const isActive = Boolean(hasComments);
    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => addComment(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          "&:hover": {
            backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          },
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer'
        }}
      >
        <GoogleMaterialIcon
          name="comment"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const FilingAttachmentButton = ({ rowData }) => {
    const hasReference =
      rowData.hasReference === true ||
      rowData.hasReference === 1 ||
      rowData.hasReference === "1";
    const isActive = Boolean(hasReference);
    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => displayAttachments(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          "&:hover": {
            backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          },
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer'
        }}
      >
        <GoogleMaterialIcon
          name="snippet_folder"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const header = renderHeader();
  const completedHeader = renderCompletedHeader();

  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleTabChange = (event, newValue) => {
    setFederalFilterSelectedValues([]);
    setSelectedFiling([]);
    setValue(newValue);
    setSelectedFilterColumn("");
    setSelectedFilterCondition("");
    setSelectedFilterValue("");
    let _filters = { ...filters };
    Object.keys(_filters).forEach((key) => {
      if (_filters[key]?.constraints) {
        _filters[key] = {
          ..._filters[key],
          constraints: _filters[key].constraints.map((constraint) => ({
            ...constraint,
            value: null,
          })),
        };
      } else if (key === "global") {
        _filters[key] = { ..._filters[key], value: null };
      }
    });
    if (search.current) {
      search.current.value = "";
    }
    setFilters(_filters);
    setActiveFilters([]);
    setIsClearIcon(false);
    setGlobalFilterValue("");
    if (newValue === "2") {
      // fetchFilingMastersCompleted()
      setIsDisabled(true);
      setRecordsInView(0);
      setIsLoading(true);
      setData([]);
      setPendingTableData([])
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRefreshRecordList(true);
    } else {
      // fetchFilingMasters()
      setIsDisabled(false);
      setIsLoading(true);
      setData([]);
      setCompletedTableData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRefreshRecordList(true);
    }
  };

  const rowExpansionTemplate = (data) => {
    // console.log("rowExpansionTemplate", data.filingPeriods);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = date => date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        let dueDate = ele.dueDate !== null ? toLocalDateString(new Date(ele.dueDate)) : null;
        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(endDate)}`;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate
        };
      });
      return (
        <div className="filingPeriodTable p-3" style={{ width: "20vw" }}>
          {/* <h5>Filing Period for {data.filingName}</h5> */}
          <DataTable value={tableData}>
            <Column field="filingPeriod" header="Filing Period"></Column>
            {/* <Column field="dueDate" header="DueDate"></Column> */}
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className="filingPeriodTable p-3">
          <h5>No Filing Period for {data.filingName}</h5>
        </div>
      );
    }
  };

  const rowExpand = (event) => {
    // console.log("rowExpand", event, expandedRows);
    // const newKeys =
    //   expandedRows !== null && expandedRows !== undefined
    //     ? Object.keys(event.data).filter(
    //         (key) => !expandedRows.hasOwnProperty(key)
    //       )[0]
    //     : Object.keys(event.data)[0];
    // let newExpanded = {};
    // newExpanded[newKeys] = event.data[newKeys];
    // // console.log("rowExpand", newKeys, newExpanded);
    setExpandedRows(event.data);
  };

  const onRowExpand = (event) => {
    // console.log("rowExpand-->", event);
    getFilingPeriod(event.data);
  };

  const getFilingPeriod = async (data) => {
    // console.log("@@Fetch getFilingPeriod", data?.filingId);
    try {
      const filingPeriod = await axios.get(
        `${API_BASE_URL}/FilingMaster/ListFilingMasterDraftPeriods/${data?.filingId}`
      );
      // console.log("getFilingPeriod res", filingPeriod.data.data);
      let tableData = filingPeriod.data.data.map((ele) => {
        let fp = `${toLocalTime(ele.startDate)} - ${toLocalTime(ele.endDate)}`;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: toLocalTime(ele.dueDate),
          initialDueDate: toLocalTime(ele.dueDate),
        };
      });
      // console.log("getFilingPeriod tableData", tableData);
      setFilingPeriodTable(tableData);
    } catch (error) {
      // console.log("@@Error:", error);
    }
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const dt = useRef(null);
  const dtComp = useRef(null);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInView, event);

    //Virtual scroll callback

    const vScroll = value === "1"
      ? dt.current.getVirtualScroller()
      : dtComp.current.getVirtualScroller()

    let range = vScroll.getRenderedRange();
    let { first, last } = range.viewport;
    console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInView * pageSize;
    let tableList = value === "1" ? pendingTableData : completedTableData
    console.log(
      "loadDataLazy totalRecords",
      firstVal,
      totalRecords,
      lazyLoading,
      tableList.length,
    );

    console.log(
      "loadDataLazy scroll check:",
      "first:", first,
      "tableList.length:", tableList.length,
      "threshold:", tableList.length - pageSize / 5,
      "firstVal:", firstVal,
      "totalRecords:", totalRecords,
      "lazyLoading:", lazyLoading
    );
    console.log("loadDataLazy", firstVal < totalRecords, first > tableList.length - pageSize / 5, !lazyLoading)

    if (firstVal < totalRecords && first > tableList.length - pageSize / 5 && !lazyLoading) {
      //scroll down
      // setIsLoading(true);
      setLazyLoading(true);
      let lastVal = firstVal + pageSize;
      console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      let records = await loadRecordsList(firstVal, lastVal, "down");
      console.log("loadDataLazy d record", records);
      if (records) {
        console.log("loadDataLazy d scrollInView", recordsInView * 100);

        //scroll to next records
        vScroll.scrollInView(recordsInView * 100);
        setRecordsInView((old) => old + 1);
        setLazyLoading(false);
        setIsLoading(false);
      }
    } else if (last < pageSize / 5 && recordsInView > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInView - 3) * pageSize;
      let lastVal = firstVal + pageSize;
      if (firstVal >= 0) {
        // setIsLoading(true);
        setLazyLoading(true);
        // console.log("loadDataLazy u firstVal", firstVal, lastVal);

        //get prev data
        let records = await loadRecordsList(firstVal, lastVal, "up");
        // console.log("loadDataLazy u record", records);
        if (records) {
          // console.log("loadDataLazy u scrollInView", (recordsInView - 3) * 100);

          //scroll to prev records
          vScroll.scrollToIndex(pageSize * 1.5);
          setRecordsInView((old) => old - 1);
          setLazyLoading(false);
          setIsLoading(false);
        }
      }
    }
  };

  const loadRecordsList = async (first, last, direction, options = {}) => {
    const { replaceExisting = false } = options;
    // console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true)
    let url = `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowListbyPagination?StartRow=${first + 1}&EndRow=${last}&RecordType=PostAward`

    // console.log("loadRecordsList recordTypeVal", recordTypeVal);
    // if (recordTypeVal !== "") {
    //   url = `${url}&RecordType=${recordTypeVal}`;
    // }

    console.log("loadRecordsList selectedYear", value, selectedYear);
    if (value === "2" && selectedYear !== "") {
      url = `${url}&StatusMove=Completed&Year=${selectedYear}`;
    }

    // console.log("loadRecordsList fliter/sort", isFilterChange, sortingData);
    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      // url filter parameters
      isFilterChange.forEach((ele) => {
        url = `${url}&${ele.name}=${ele.val}${ele.searchType ? `&${ele.searchType}=${ele.searchTypeVal}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter)
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    // console.log("loadRecordsList url", url);
    try {
      //get data
      const res = await axios.get(url);
      console.log("loadRecordsList res", res.data, res.data.data.items);

      if (res.data) {
        setIsLoading(true);
        let ogList = []
        if (replaceExisting) {
          ogList = [];
        } else if (value === "2" && selectedYear !== "") {
          ogList = completedTableData.map((ele) => ele)
        } else {
          ogList = pendingTableData.map((ele) => ele)
        }
        await modifyList(res.data.data.items, direction, ogList);
        setTotalRecords(res.data.data.totalItems);

        return res.data.data.items;
      } else {
        return false;
      }
    } catch (err) {
      // console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data
      const updList = list
        .map((item) => {
          // console.log(`filtered data ...`, item);
          const _stateList = getStateName(item.stateInfo);
          const awardTypeName =
            item.awardType && item.awardType.length > 0
              ? item.awardType[0].awardTypeName
              : "";

          const awardingAgencyName =
            item.awardingAgency && item.awardingAgency.length > 0
              ? item.awardingAgency[0].awardingAgencyName
              : "";

          if (item.juristiction?.includes("Federal")) {
            return {
              ...item,
              federalCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateCategories: null,
              stateList: _stateList,
              awardType: awardTypeName,
              awardingAgency: awardingAgencyName,
            };
          } else if (item.juristiction?.includes("Both")) {
            return {
              ...item,
              federalCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              stateList: _stateList,
              awardType: awardTypeName,
              awardingAgency: awardingAgencyName,
            };
          } else {
            return {
              ...item,
              stateCategories:
                item.programInfo.length > 0
                  ? item.programInfo[0].programName
                  : "",
              federalCategories: null,
              stateList: _stateList,
              awardType: awardTypeName,
              awardingAgency: awardingAgencyName,
            };
          }
        });
      const _jusrisdictions = updList.map((item) =>
        item.juristiction ? item.juristiction : ""
      );
      const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      setJurisdiction(_uniqJurisdictions);
      // let pendingList = updList.filter(
      //   (ele) => ele.workflowStatus === "Pending"
      // );

      let tableList = value === "1" ? pendingTableData : completedTableData
      console.log("modifyList updCustomers", updList, tableList);

      let updFilingMastersList;
      if (direction === "down") {
        //scroll down
        if (tableList.length >= 200) {
          //list > 200

          //slice 2 half of list
          let unloadList = ogList.slice(
            ogList.length - pageSize,
            ogList.length
          );
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updFilingMastersList = [...unloadList, ...updList];
          // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

          // let list = updFilingMastersList.map((ele)=>ele)
          // setClientFiling(updFilingMastersList);
        } else {
          //list < 200

          // add new data to list
          updFilingMastersList = [...ogList, ...updList];
          // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        }
      } else if (direction === "up") {
        //scroll up
        if (tableList.length >= 200) {
          //list > 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        } else {
          //list < 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        }
      }

      if (value === "2" && selectedYear !== "") {
        setCompletedTableData(() => updFilingMastersList)
        setFilingMasterApprovalsCompleted(updFilingMastersList)
      } else {
        setData(() => updFilingMastersList);
        setPendingTableData(() => updFilingMastersList)
        setFilingMasterApprovalsPending(updFilingMastersList)
      }

      setRefreshRecordList(false)
      setLazyLoading(false)
      setIsLoading(false);
      return updFilingMastersList
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setRefreshRecordList(false)
      setLazyLoading(false)
      setIsLoading(false);
      setFilingMasterApprovalsCompleted([])
      setFilingMasterApprovalsPending([])
      // setClientFiling([]);
      return [];
    }
  };

  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        // console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `SearchByStateInfo`,
                  val: getStateCode(ele),
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `StateInfoSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `SearchByStateInfo`,
                val: getStateCode(e.filters[col].constraints[0].value),
                searchType: `StateInfoSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "awardType") {
            filterChange.push({
              name: `SearchByAwardType`,
              val: e.filters[col].constraints[0].value,
              searchType: `AwardTypeSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "awardingAgency") {
            filterChange.push({
              name: `SearchByAwardAgency`,
              val: e.filters[col].constraints[0].value,
              searchType: `AwardAgencySearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: e.filters[col].constraints[0].value,
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "federalCategories") {
            const federalValues = Array.isArray(
              e.filters[col].constraints[0].value
            )
              ? e.filters[col].constraints[0].value
              : [e.filters[col].constraints[0].value];
            federalValues
              .filter((ele) => ele !== null && ele !== undefined && ele !== "")
              .forEach((ele, i) => {
                // console.log(
                //   "onFilterChange i",
                //   i + 1,
                //   e.filters[col].constraints[0].value.length
                // );
                let changeItem = {
                  name: `WhoMustFileFederal`,
                  val: ele,
                };
                if (i + 1 === federalValues.length) {
                  changeItem.searchType = `WhoMustFileFederalSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              });
          } else if (col === "stateCategories") {
            const stateValues = Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value
              : [e.filters[col].constraints[0].value];
            stateValues
              .filter((ele) => ele !== null && ele !== undefined && ele !== "")
              .forEach((ele, i) => {
                let changeItem = {
                  name: `WhoMustFileInState`,
                  val: ele,
                };
                if (i + 1 === stateValues.length) {
                  changeItem.searchType = `WhoMustFileInStateSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: e.filters[col].constraints[0].value,
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          }
        }
      });
    }
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInView(0);
    setIsLoading(true);
    setData([]);
    setPendingTableData([])
    setCompletedTableData([])
  };

  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInView(0);
      setIsLoading(true);
      setData([]);
      setPendingTableData([])
      setCompletedTableData([])
    }
  };


  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrder"
      }
    } else if (val === "awardType") {
      return {
        SortByParameter: "SortByAwardType",
        SortByVal: "AwardType",
        SortOrderParameter: "SortOrderAwardType"
      }
    } else if (val === "awardingAgency") {
      return {
        SortByParameter: "SortByAwardingAgency",
        SortByVal: "AwardingAgency",
        SortOrderParameter: "SortOrderAwardingAgency"
      }
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder"
      }
    }
  }

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, lazyLoading );
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      setLazyLoading(true)
      const sortAndFilterApiCall = async () => {
        let records = await loadRecordsList(0, 100, "down");
        setRecordsInView(1);
        console.log("recordsCheck", records);
        setIsLoading(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const handleRefreshList = () => {
    //Virtual scroll callback
    const vScroll = value === "1"
      ? dt.current.getVirtualScroller()
      : dtComp.current.getVirtualScroller();
    let range = vScroll.getRenderedRange();
    console.log("refreshTable vScroll", vScroll, range);

    const clientSelected = selectedFiling;
    setRecordsInView(0)
    setRefreshDetails({
      viewport: range.viewport,
      pageInView: 0,
      noOfPages: 1,
      clientSelected
    })

    setIsLoading(true);
    //setSelectedFiling([]);
    setData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setLazyLoading(false);
    setResetListOnRefresh(true);
    setRefreshRecordList(true);
  }

  const refreshRecords = async () => {
    console.log("refreshRecords")

    //Virtual scroll callback
    const vScroll = value === "1"
      ? dt.current.getVirtualScroller()
      : dtComp.current.getVirtualScroller()

    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll", vScroll, range);

    let records
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (resetListOnRefresh) {
      records = await loadRecordsList(0, pageSize, "down", {
        replaceExisting: true,
      });
    } else if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize
      records = await loadRecordsList(first, first + refreshDetails?.noOfPages * pageSize, "down");
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }

    if (records) {
      console.log("refreshRecords refreshDetails", refreshDetails)
      if (resetListOnRefresh) {
        setRecordsInView(1);
      } else if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        setRecordsInView((old) => old + refreshDetails?.noOfPages);
        // setRefreshDetails(null)
      } else {
        setRecordsInView((old) => old + 1);
      }
      setResetListOnRefresh(false);
      setLazyLoading(false)
    }
  }

  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords()
    }

  }, [refreshRecordList, lazyLoading])

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
  }, [recordsInView]);

  useEffect(() => {
    console.log("pendingTableData,", pendingTableData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingTableData, pendingTableData.length, JSON.stringify(pendingTableData)]);

  useEffect(() => {
    console.log("filingMasterApprovals,", filingMasterApprovals);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingMasterApprovals]);

  useEffect(() => {
    console.log("filingMasterApprovalsCompleted,", filingMasterApprovalsCompleted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingMasterApprovalsCompleted]);

  useEffect(() => { console.log("isLoading", isLoading) }, [isLoading])

  useEffect(() => { console.log("lazyLoading", lazyLoading) }, [lazyLoading])

  return (
    <Fragment>
      {isLoading && (
        <CircularProgress
          sx={{ position: 'fixed', top: '50%', left: '50%', zIndex: 9999, color: tableHeaderColor }}
        />
      )}
      <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <Grid sx={{ height: "100%", width: isMobile ? "100%" : "93%" }}>
          <PostAwardApprovalListApprove
            show={showFilter}
            dockAt="right"
            drafts={selectedFiling}
            handleClose={closeFilter}
            updateSelectedWorkflow={updateSelectedWorkflow}
            refreshList={handleRefreshList}
          />

          <Grid sx={{ height: "100%" }}>
            <style>{`
  .p-datatable.frozen-filing-approval-pending-pa,
  .p-datatable.frozen-filing-approval-completed-pa {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tableBackgroundColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-wrapper,
  .frozen-filing-approval-completed-pa .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    height: 550px !important;
    max-height: 550px !important;
    background: ${tableBackgroundColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-header,
  .frozen-filing-approval-completed-pa .p-datatable-header {
    background: ${tableBackgroundColor} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-table,
  .frozen-filing-approval-completed-pa .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .frozen-filing-approval-pending-pa .p-selection-column,
  .frozen-filing-approval-completed-pa .p-selection-column {
    text-align: center !important;
  }

  .frozen-filing-approval-pending-pa .p-selection-column .p-checkbox,
  .frozen-filing-approval-completed-pa .p-selection-column .p-checkbox {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  /* HEADER */
  .frozen-filing-approval-pending-pa .p-datatable-thead > tr,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-thead > tr:first-child > th:first-child,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-thead > tr:first-child > th:last-child,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:last-child > td:first-child,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:last-child > td:last-child,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-thead > tr > th,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr > th {
    background: transparent !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-thead > tr > th:last-child,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  /* Frozen columns z-index fix and dark purple background */
  .frozen-filing-approval-pending-pa .p-datatable-thead > tr > th.p-frozen-column,
  .frozen-filing-approval-completed-pa .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 2 !important;
    background: color-mix(in srgb, ${tableHeaderColor} 85%, black) !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending-pa .p-sortable-column-icon,
  .frozen-filing-approval-completed-pa .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody,
  .frozen-filing-approval-completed-pa .p-datatable-tbody {
    background: ${tableBackgroundColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-virtualscroller-content,
  .frozen-filing-approval-completed-pa .p-virtualscroller-content {
    background: ${tableBackgroundColor} !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:nth-child(odd) > td,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:nth-child(even) > td,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  /* FORCE PURPLE BORDERS ON ALL CELLS - MUST BE LAST */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr > td,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr > td {
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr > td:last-child,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* HOVER - Only for clickable cells (Filing Name) */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn-pa:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn-pa:hover,
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn-pa:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn-pa:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 8%, white) !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn-pa:hover *,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn-pa:hover *,
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn-pa:hover *,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn-pa:hover * {
    font-weight: 600 !important;
    color: ${tableHeaderColor} !important;
  }

  /* Non-clickable cells - no hover effect */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn-pa):not(.expandableColumn-pa):hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn-pa):not(.expandableColumn-pa):hover {
    background-color: ${tableBackgroundColor} !important;
    font-weight: 400 !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn-pa):not(.expandableColumn-pa):not(.indicatorsColumn):hover *,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn-pa):not(.expandableColumn-pa):not(.indicatorsColumn):hover * {
    font-weight: 400 !important;
    color: #000000 !important;
  }

  /* PrimeReact applies a separate hover state to frozen cells; keep non-clickable frozen columns neutral. */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td.p-frozen-column:not(.filingNameColumn-pa):not(.expandableColumn-pa):hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td.p-frozen-column:not(.filingNameColumn-pa):not(.expandableColumn-pa):hover {
    background-color: ${tableBackgroundColor} !important;
    font-weight: 400 !important;
  }

  /* Indicators column - no hover effect */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td.indicatorsColumn:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td.indicatorsColumn:hover {
    background-color: ${tableBackgroundColor} !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  /* SELECTED ROW */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* PrimeReact frozen columns keep their own background; force selection highlight on fixed cells too. */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn,
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* Row expander: prevent parent table wrapper height from inflating nested table */
  .frozen-filing-approval-pending-pa .filingPeriodTable .p-datatable-wrapper,
  .frozen-filing-approval-completed-pa .filingPeriodTable .p-datatable-wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover,
  .frozen-filing-approval-completed-pa .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-checkbox .p-checkbox-box.p-focus,
  .frozen-filing-approval-completed-pa .p-checkbox .p-checkbox-box.p-focus,
  .frozen-filing-approval-pending-pa .p-checkbox.p-focus .p-checkbox-box,
  .frozen-filing-approval-completed-pa .p-checkbox.p-focus .p-checkbox-box {
    border-color: ${tableHeaderColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .frozen-filing-approval-pending-pa .p-row-toggler,
  .frozen-filing-approval-completed-pa .p-row-toggler {
    color: ${tableHeaderColor} !important;
    box-shadow: none !important;
  }

  .frozen-filing-approval-pending-pa .p-row-toggler:hover,
  .frozen-filing-approval-completed-pa .p-row-toggler:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-row-toggler:focus,
  .frozen-filing-approval-completed-pa .p-row-toggler:focus,
  .frozen-filing-approval-pending-pa .p-row-toggler.p-focus,
  .frozen-filing-approval-completed-pa .p-row-toggler.p-focus {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-loading-icon,
  .frozen-filing-approval-completed-pa .p-datatable-loading-icon {
    color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending-pa .p-datatable-loading-icon svg,
  .frozen-filing-approval-completed-pa .p-datatable-loading-icon svg {
    stroke: ${tableHeaderColor} !important;
  }

  .postaward-master-approval-overlay-panel .p-overlaypanel-close,
  .postaward-master-approval-overlay-panel .p-overlaypanel-close:hover {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .postaward-master-approval-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon,
  .postaward-master-approval-overlay-panel .p-overlaypanel-close .pi,
  .postaward-master-approval-overlay-panel .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  /* A selected frozen cell must retain the selection tint when hovered. */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td:hover,
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* This table marks selection on the checkbox rather than consistently on the row. */
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:has(.p-checkbox-box.p-highlight) > td,
  .frozen-filing-approval-pending-pa .p-datatable-tbody > tr:has(.p-checkbox-box.p-highlight) > td:hover,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:has(.p-checkbox-box.p-highlight) > td,
  .frozen-filing-approval-completed-pa .p-datatable-tbody > tr:has(.p-checkbox-box.p-highlight) > td:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* SCROLLBAR */
  .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${tableHeaderColor};
  }

  .filingPeriodTable .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }
`}</style>
            <div
              className="card masterFilingApproval"
              style={{
                maxWidth: "90vw",
                padding: "1rem",
                margin: "1rem",
                background: containerBackgroundColor,
                borderRadius: "8px",
                overflow: "visible",
                border: "none",
              }}
            >
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleTabChange}>
                    <Tab label="Pending" value="1" disabled={isLoading} />
                    <Tab label="Completed" value="2" disabled={isLoading} />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <DataTable
                    ref={dt}
                    key="pending"
                    scrollable
                    resizableColumns
                    loading={isLoading}
                    showGridlines
                    className="frozen-filing-approval-pending-pa"
                    value={pendingTableData}
                    selection={selectedFiling}
                    onSelectionChange={(e) => setSelectedFiling(e.value)}
                    dataKey="workflowId"
                    style={{ minHeight: "50vh" }}
                    onRowSelect={onRowSelect}
                    onRowToggle={(e) => rowExpand(e)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    // paginator={!viewAll}
                    // rows={viewAll ? clients.length : 10}
                    // rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    filterMode="multiple"
                    globalFilterFields={["filingName"]}
                    header={header}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    scrollHeight='550px'
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    <Column expander={true} style={{ width: "5rem" }} />
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: "3rem" }}
                    >
                      Select
                    </Column>
                    <Column
                      headerStyle={{ width: "3rem" }}
                      header="Indicators"
                      className="indicatorsColumn"
                      body={(rowData) => (
                        <>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <CustomCommentButton rowData={rowData} />
                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field="approverName"
                      header="Approver Name"
                      sortable
                      frozen
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="filingName"
                      header="Filing Name"
                      sortable
                      frozen
                      className="filingNameColumn-pa"
                      style={{ minWidth: "12rem", maxWidth: "25rem" }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    <Column
                      field="recentDate"
                      header="Time Stamp"
                      sortable
                      style={{ minWidth: "15rem" }}
                      frozen
                      body={displayTimeStamp}
                    ></Column>
                    <Column
                      field="filingFrequency"
                      header="Filing Frequency"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="awardType"
                      header="Award Type"
                      sortable
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="awardingAgency"
                      header="Award Agency"
                      sortable
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="stateList"
                      header="State"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="ruleInfo"
                      header="Rule Info"
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field="required"
                      header="Required"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="federalCategories"
                      header="Who Must File Federal"
                      className="expandableColumn-pa"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    ></Column>
                    <Column
                      field="stateCategories"
                      header="Who Must File in State"
                      className="expandableColumn-pa"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    ></Column>
                    <Column
                      field="jsicontactName"
                      header="JSI Staff"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="juristiction"
                      header="Jurisdiction"
                      sortable
                      style={{ minWidth: "14rem" }}
                    ></Column>
                    <Column
                      field="notes"
                      header="Notes"
                      style={{ minWidth: "21rem", maxWidth: "21rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                    ></Column>
                  </DataTable>
                </TabPanel>
                <TabPanel value="2">
                  <DataTable
                    ref={dtComp}
                    key="completed"
                    scrollable
                    resizableColumns
                    loading={isLoading}
                    showGridlines
                    className="frozen-filing-approval-completed-pa"
                    value={completedTableData}
                    selection={selectedFiling}
                    onSelectionChange={(e) => setSelectedFiling(e.value)}
                    dataKey="workflowId"
                    style={{ minHeight: "50vh" }}
                    onRowSelect={onRowSelect}
                    onRowToggle={(e) => rowExpand(e)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    // paginator={!viewAll}
                    // rows={viewAll ? clients.length : 10}
                    // rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    filterMode="multiple"
                    globalFilterFields={["filingName"]}
                    header={completedHeader}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    scrollHeight='550px'
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    <Column expander={true} style={{ width: "5rem" }} />
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: "3rem" }}
                    >
                      Select
                    </Column>
                    <Column
                      headerStyle={{ width: "3rem" }}
                      header="Indicators"
                      className="indicatorsColumn"
                      body={(rowData) => (
                        <>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <CustomCommentButton rowData={rowData} />
                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field="filingName"
                      header="Filing Name"
                      sortable
                      frozen
                      className="filingNameColumn-pa"
                      style={{ minWidth: "12rem", maxWidth: "25rem" }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    <Column
                      field="filingFrequency"
                      header="Filing Frequency"
                      frozen
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="recentDate"
                      header="Time Stamp"
                      sortable
                      style={{ minWidth: "15rem" }}
                      frozen
                      body={displayTimeStamp}
                    ></Column>
                    <Column
                      field="awardType"
                      header="Award Type"
                      sortable
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="awardingAgency"
                      header="Award Agency"
                      sortable
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="stateList"
                      header="State"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="ruleInfo"
                      header="Rule Info"
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field="required"
                      header="Required"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="workflowStatus"
                      header="Status"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="federalCategories"
                      header="Who Must File Federal"
                      className="expandableColumn-pa"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    ></Column>
                    <Column
                      field="stateCategories"
                      header="Who Must File in State"
                      className="expandableColumn-pa"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    ></Column>
                    <Column
                      field="jsicontactName"
                      header="JSI Staff"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="juristiction"
                      header="Jurisdiction"
                      sortable
                      style={{ minWidth: "14rem" }}
                    ></Column>
                    <Column
                      field="notes"
                      header="Notes"
                      style={{ minWidth: "21rem", maxWidth: "21rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                    ></Column>
                  </DataTable>
                </TabPanel>
              </TabContext>
            </div>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: isMobile ? "none" : "block",
            height: "100%",
            width: "5%",
            position: "sticky",
            top: 10,
            alignSelf: "flex-start",
            zIndex: 2,
          }}
        >
          <div
            style={{
              height: "100%",
              background: "transparent",
              marginTop: "0",
            }}
          >
            <Item
              sx={{
                height: "100%",
                background: "transparent",
                boxShadow: "none",
                borderRadius: "50px",
                overflow: "visible"
              }}
            >
              <PostAwardApprovalListToolbox
                isLoading={isLoading}
                addComment={addComment}
                approveDraft={approveDraft}
                isDisabled={isDisabled}
                displayAttachments={displayAttachments}
                displayHistory={displayHistory}
              />
            </Item>
          </div>
        </Grid>
      </div>
      <CustomDialog
        header="Selection Required"
        visible={showAlert}
        onHide={closeAlert}
        icon="⚠️"
      >
        {alertMessage}
      </CustomDialog>
      {
        <PostAwardApprovalListComments
          show={showComments}
          dockAt="right"
          workflow={selectedFiling[0]}
          rowData={selectedRowData}
          comments={comments}
          handleClose={closeComments}
          refreshList={handleRefreshList}
          value={value}
        />
      }
      {
        <PostAwardApprovalListReferenceDocument
          show={showAttachments}
          dockAt="right"
          filing={selectedFiling[0]}
          attachments={attachments}
          handleClose={closeAttachments}
        />
      }
      {
        <PostAwardApprovalListHistory
          show={showHistory}
          dockAt="right"
          tracker={selectedFiling[0]}
          activityHistory={activityHistory}
          commentActivityHistory={commentActivityHistory}
          handleClose={closeHistory}
        />
      }
      <Popover
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: tokens.colors.offWhite,
            border: "1px solid #ccc",
          },
        }}
      >
        <Box sx={{ p: 2, width: 350, maxHeight: 500, overflowY: "auto" }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>
            Filter
          </Typography>

          <TextField
            select
            fullWidth
            label="Column"
            size="small"
            value={selectedFilterColumn}
            onChange={(e) => {
              setSelectedFilterColumn(e.target.value);
              setSelectedFilterValue("");
            }}
          >
            {getFilterColumnsForCurrentTab().map((column) => (
              <MenuItem key={column.value} value={column.value}>
                {column.label}
              </MenuItem>
            ))}
          </TextField>

          {selectedFilterColumn && (
            <TextField
              select
              fullWidth
              label="Condition"
              size="small"
              sx={{ mt: 2 }}
              value={selectedFilterCondition}
              onChange={(e) => {
                const nextCondition = e.target.value;
                setSelectedFilterCondition(nextCondition);
                setSelectedFilterValue(
                  shouldUseMultiSelectFilterValue(selectedFilterColumn, nextCondition)
                    ? []
                    : ""
                );
              }}
            >
              {selectedFilterColumn !== "required" && selectedFilterColumn !== "juristiction" && (
                <MenuItem value={FilterMatchMode.CONTAINS}>Contains</MenuItem>
              )}
              {selectedFilterColumn !== "required" && selectedFilterColumn !== "juristiction" && (
                <MenuItem value={FilterMatchMode.NOT_CONTAINS}>Is Not</MenuItem>
              )}
              <MenuItem value={FilterMatchMode.EQUALS}>Is</MenuItem>
            </TextField>
          )}

          {selectedFilterColumn && selectedFilterCondition && (
            getFilterValueOptions(selectedFilterColumn).length > 0 ? (
              shouldUseMultiSelectFilterValue(selectedFilterColumn, selectedFilterCondition) ? (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Select Values:</Typography>
                  <Box sx={{
                    maxHeight: 200,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                    backgroundColor: tokens.colors.offWhite
                  }}>
                    <FormGroup>
                      {getFilterValueOptions(selectedFilterColumn).map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={
                                Array.isArray(selectedFilterValue) &&
                                selectedFilterValue.includes(option)
                              }
                              onChange={() => {
                                const currentValues = Array.isArray(selectedFilterValue)
                                  ? selectedFilterValue
                                  : [];
                                const nextValues = currentValues.includes(option)
                                  ? currentValues.filter((value) => value !== option)
                                  : [...currentValues, option];
                                setSelectedFilterValue(nextValues);
                              }}
                              size="small"
                            />
                          }
                          label={option}
                          sx={{
                            fontSize: "14px",
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px"
                            },
                            mb: 0.5
                          }}
                        />
                      ))}
                    </FormGroup>
                  </Box>
                </Box>
              ) : shouldUseRadioFilterValue(selectedFilterColumn, selectedFilterCondition) ? (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Select Value:</Typography>
                  <Box sx={{
                    maxHeight: 200,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                    backgroundColor: tokens.colors.offWhite
                  }}>
                    <RadioGroup
                      value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                      onChange={(e) => setSelectedFilterValue(e.target.value)}
                    >
                      {getFilterValueOptions(selectedFilterColumn).map((option) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio size="small" />}
                          label={option}
                          sx={{
                            fontSize: "14px",
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px"
                            },
                            mb: 0.5
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </Box>
                </Box>
              ) : (
                <TextField
                  select
                  fullWidth
                  label="Value"
                  size="small"
                  sx={{ mt: 2 }}
                  value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                  onChange={(e) => setSelectedFilterValue(e.target.value)}
                >
                  {getFilterValueOptions(selectedFilterColumn).map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              )
            ) : (
              <TextField
                fullWidth
                label="Value"
                size="small"
                sx={{ mt: 2 }}
                value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                onChange={(e) => setSelectedFilterValue(e.target.value)}
              />
            )
          )}

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <TrackNowButton size="small" variant="secondary" onClick={handleFilterClear}>
              Clear
            </TrackNowButton>
            <TrackNowButton size="small" variant="primary" onClick={applyFilterFromPopover}>
              Apply Filter
            </TrackNowButton>
          </Box>
        </Box>
      </Popover>
    </Fragment>
  );
};
export default PostAwardApprovalList;
